<template>
  <div class="fct-acronym">
    <span>{{acronym}}</span>
  </div>
</template>

<script>
  export default {
    name: "NameAcronym",
    props: ['fullName'],
    data() {
      return {}
    },
    computed: {
      acronym: function f() {
        return this.fullName.split(' ').slice(0, 2).map(term => term[0].toUpperCase()).join('')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../node_modules/bulma/sass/utilities/mixins";

  .fct-acronym {
    display: flex;
    float: left;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: #2659c1;
    font-family: montserratbold;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.1);

    @include mobile() {
      border-color: rgba(#fff, 0.2);
    }

    border-radius: 50%;
    height: 40px;
    width: 40px;
    margin-right: 5px;
    border-width: 5px;

    > span {
      display: inline-block;
    }

    @include mobile() {
      height: 94px;
      width: 94px;

      border-width: 7px;
      font-size: 22px;
    }
  }
</style>
